import React from 'react';
import entireLogo from '../assets/entire-logo.png';
import { useLang } from '../i18n/useLang';

const socialLinks = [
  {
    key: 'whatsapp',
    href: "https://wa.me/32466230376?text=I'm%20interested%20in%20your%20services.",
    label: 'WhatsApp',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-[18px] h-[18px]">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
        <path d="M12 0C5.373 0 0 5.373 0 12c0 2.124.558 4.118 1.533 5.845L.054 23.447a.75.75 0 0 0 .916.948l5.741-1.505A11.943 11.943 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.75a9.713 9.713 0 0 1-4.96-1.36l-.356-.21-3.684.967.984-3.595-.232-.37A9.712 9.712 0 0 1 2.25 12C2.25 6.615 6.615 2.25 12 2.25S21.75 6.615 21.75 12 17.385 21.75 12 21.75z" />
      </svg>
    ),
    hoverColor: '#25D366',
  },
  {
    key: 'email',
    href: 'mailto:contact@novafrik-ai.com?subject=Hello%20NovaFrik%20AI',
    label: 'Email',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="w-[18px] h-[18px]">
        <rect x="2" y="4" width="20" height="16" rx="2" />
        <path d="m2 7 10 7 10-7" />
      </svg>
    ),
    hoverColor: '#EA4335',
  },
  {
    key: 'linkedin',
    href: 'https://www.linkedin.com/company/novafrik-ai',
    label: 'LinkedIn',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-[18px] h-[18px]">
        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
      </svg>
    ),
    hoverColor: '#0A66C2',
  },
  {
    key: 'x',
    href: 'https://x.com/novafrik_ai',
    label: 'X / Twitter',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-[18px] h-[18px]">
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.747l7.73-8.835L1.254 2.25H8.08l4.253 5.622 5.911-5.622zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
      </svg>
    ),
    hoverColor: '#eeeef5',
  },
  {
    key: 'cal',
    href: 'https://cal.com/willy-carlos-tchuitcheu-lz7ww7/15min?overlayCalendar=true',
    label: 'Book a 15-min call',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="w-[18px] h-[18px]">
        <rect x="3" y="4" width="18" height="18" rx="2" />
        <path d="M16 2v4M8 2v4M3 10h18" />
        <circle cx="12" cy="16" r="1.5" fill="currentColor" stroke="none" />
      </svg>
    ),
    hoverColor: '#0069FF',
  },
];

function SocialIcon({ s }) {
  const [hovered, setHovered] = React.useState(false);
  return (
    <a
      href={s.href}
      target={s.key === 'email' ? '_self' : '_blank'}
      rel="noopener noreferrer"
      aria-label={s.label}
      title={s.label}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      className="flex items-center justify-center w-9 h-9 rounded-xl border border-white/[0.07] bg-nf-bg3 no-underline transition-all duration-200 hover:border-white/[0.15] hover:-translate-y-0.5"
      style={{ color: hovered ? s.hoverColor : '#55556a' }}
    >
      {s.icon}
    </a>
  );
}

export default function Footer({ navigate }) {
  const { t } = useLang();
  return (
    <footer className="bg-nf-bg2 border-t border-white/[0.06] pt-12 pb-7 px-4 sm:px-8 lg:px-20">
      <div className="max-w-[1100px] mx-auto">

        {/* Top section: 3 columns — logo | nav | contact */}
        <div className="grid grid-cols-1 sm:grid-cols-[auto_1fr_auto] gap-10 sm:gap-8 mb-10">

          {/* Col 1: Logo */}
          <a
            className="cursor-pointer group shrink-0 self-start"
            onClick={() => navigate('home')}
            aria-label="NovaFrik AI — Home">
            <img
              src={entireLogo}
              alt="NovaFrik AI"
              className="h-14 sm:h-16 w-auto object-contain drop-shadow-[0_0_14px_rgba(109,40,217,0.4)] transition-opacity duration-200 group-hover:opacity-90"
              style={{ mixBlendMode: 'screen', filter: 'brightness(1.05)' }}
            />
          </a>

          {/* Col 2: Nav links */}
          <nav className="flex flex-wrap gap-x-7 gap-y-3 sm:justify-center sm:items-start sm:pt-1">
            {['home', 'services', 'about', 'learn', 'blog', 'faq'].map(p => (
              <a
                key={p}
                className="text-[14px] text-nf-t3 no-underline transition-colors cursor-pointer hover:text-nf-text"
                onClick={() => navigate(p)}>
                {p === 'blog' ? t('footer.research') : p === 'faq' ? t('nav.faq') : p.charAt(0).toUpperCase() + p.slice(1).replace('-', ' ')}
              </a>
            ))}
          </nav>

          {/* Col 3: Contact + socials */}
          <div className="flex flex-col gap-4 sm:items-end">
            <a
              href="mailto:contact@novafrik-ai.com?subject=Hello%20NovaFrik%20AI"
              className="text-[13px] text-nf-t3 no-underline transition-colors hover:text-nf-t2 tracking-wide">
              contact@novafrik-ai.com
            </a>
            <div className="flex items-center gap-2">
              {socialLinks.map(s => <SocialIcon key={s.key} s={s} />)}
            </div>
          </div>
        </div>

        {/* Bottom row: copyright */}
        <div className="border-t border-white/[0.05] pt-5 text-center">
          <p className="text-[12px] text-nf-t3">{t('footer.copyright')}</p>
        </div>

      </div>
    </footer>
  );
}
